import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "lib-flexible"
import "./assets/css/index.scss"
import "@/icons"
import Vant from 'vant';
import 'vant/lib/index.css';
import myComponent from "./api/component.js"
let api = require("@/api/api.js") 
Vue.prototype.$api = {...api}
Vue.prototype.$bus=new Vue()
myComponent(Vue)
Vue.use(Vant);
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
